import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import Logo from "../../../Assets/img/paperboylogo.png";
import Logo from "../../../Assets/img/the-paperboy-logo-5.png";

import author from "../../../Assets/img/authors/author.webp";
import author1 from "../../../Assets/img/authors/author2.webp";
import author2 from "../../../Assets/img/authors/author3.webp";

import { BASE_URL, security_key } from "./../../../global";
import axios from "axios";
import { toast } from "react-toastify";

const Footer = () => {
    const [loading, setLoading] = useState(false);
    const [tags, setTags] = useState([]);
    const [categories, setCategories] = useState([]);
    const [links, setLinks] = useState({});

    useEffect(() => {
        getAllTags();
        getAllNavCategory();
        getAdminSocialMediaLinks();
    }, []);

    const getAllNavCategory = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllNavCategory",
        });

        const output = response.data;

        if (output.length > 0) {
            setCategories(output);
        }
    };

    const getAllTags = async () => {
        try {
            setLoading(true);

            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getAllTags",
            });

            const output = response.data;

            if (output.length > 0) {
                // Create a Set to track unique tags (case-insensitive)
                const seen = new Set();
                const uniqueTags = output.filter((item) => {
                    const tagLower = item.tag.toLowerCase();
                    if (seen.has(tagLower)) {
                        return false;
                    } else {
                        seen.add(tagLower);
                        return true;
                    }
                });
                setTags(uniqueTags);
            }
        } catch (error) {
            toast.error("Error fetching tags." + error, {
                autoClose: 3000,
            });
        } finally {
            setLoading(false);
        }
    };

    const getAdminSocialMediaLinks = async () => {
        try {
            setLoading(true);

            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getAdminSocialMediaLinks",
            });

            const output = response.data;

            if (Object.keys(output).length > 0) {
                setLinks(output);
            } else {
                throw new Error("Oops! Something went wrong.");
            }
        } catch (error) {
            console.error("Error fetching links" + error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <footer className="border bg-grey">
            <div className="footer-area">
                <div className="container">
                    <div className="row pt-30 pb-30">
                        <div className="col-12">
                            <div className="divider-2 mb-30"></div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-lg-0 mb-md-4 mb-sm-4">
                            <div className="sidebar-widget widget-latest-posts pr-50">
                                <h4 className="widget-header text-uppercase font-weight-bold color-black">
                                    <img src={Logo} className="mb-2" alt="" />
                                </h4>
                                <div className="textwidget">
                                    <p>Start writing, no matter what. The water does not flow until the faucet is turned on.</p>
                                    <p>
                                        <strong className="color-black">Address</strong>
                                        <br />
                                        123 Main Street
                                        <br />
                                        New York, NY 10001
                                    </p>
                                    <p>
                                        <strong className="color-black">Hours</strong>
                                        <br />
                                        Monday—Friday: 9:00AM–5:00PM
                                        <br />
                                        Saturday &amp; Sunday: 11:00AM–3:00PM
                                    </p>
                                    <ul className="header-social-network d-inline-block list-inline font-small">
                                        <li className="list-inline-item">
                                            <span className="text-uppercase ">
                                                <strong className="color-black">Follow us:</strong>
                                            </span>
                                        </li>
                                        <li className="list-inline-item">
                                            <a
                                                className="social-icon facebook-icon text-xs-center"
                                                href={links.facebook ? links.facebook : "javascript:void(0)"}
                                                target="_blank"
                                            >
                                                <i className="ti-facebook"></i>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a
                                                className="social-icon twitter-icon text-xs-center"
                                                href={links.twitter ? links.twitter : "javascript:void(0)"}
                                                target="_blank"
                                            >
                                                <i className="ti-twitter-alt"></i>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a
                                                className="social-icon pinterest-icon text-xs-center"
                                                href={links.pinterest ? links.pinterest : "javascript:void(0)"}
                                                target="_blank"
                                            >
                                                <i className="ti-pinterest"></i>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a
                                                className="social-icon instagram-icon text-xs-center"
                                                href={links.instagram ? links.instagram : "javascript:void(0)"}
                                                target="_blank"
                                            >
                                                <i className="ti-instagram"></i>
                                            </a>
                                        </li>
                                        {/* <li className="list-inline-item">
                                            <a className="social-icon facebook-icon text-xs-center" target="_blank" href="javascript:void(0)">
                                                <i className="ti-facebook"></i>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a className="social-icon twitter-icon text-xs-center" target="_blank" href="javascript:void(0)">
                                                <i className="ti-twitter-alt"></i>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a className="social-icon pinterest-icon text-xs-center" target="_blank" href="javascript:void(0)">
                                                <i className="ti-pinterest"></i>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a className="social-icon instagram-icon text-xs-center" target="_blank" href="javascript:void(0)">
                                                <i className="ti-instagram"></i>
                                            </a>
                                        </li> */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <div className="">
                                <h5 className="mb-20 text-start fw-bold">Stay Updated on Headlines & Trends</h5>{" "}
                            </div>
                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <div className="col mb-3">
                                    <ul className="float-left font-small">
                                        {tags.slice(0, 10).map((row, index) => (
                                            <li key={"tag" + index} className="cat-item cat-item-2">
                                                <Link to={/category/ + row.fk_cat_key}>#{row.tag}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="col mb-3">
                                    <ul className="float-left  font-small">
                                        {tags.slice(10, 20).map((row, index) => (
                                            <li key={"tag" + index} className="cat-item cat-item-2">
                                                <Link to={/category/ + row.fk_cat_key}>#{row.tag}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="col mb-3">
                                    <ul className="float-left  font-small">
                                        {tags.slice(20, 30).map((row, index) => (
                                            <li key={"tag" + index} className="cat-item cat-item-2">
                                                <Link to={/category/ + row.fk_cat_key}>#{row.tag}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="col mb-3">
                                    <ul className="float-left  font-small">
                                        {tags.slice(30, 40).map((row, index) => (
                                            <li key={"tag" + index} className="cat-item cat-item-2">
                                                <Link to={/category/ + row.fk_cat_key}>#{row.tag}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom-area text-center text-muted">
                <div className="container">
                    <div className="footer-border pt-20 pb-20">
                        <div className="row d-flex mb-15">
                            <div className="col-12">
                                <ul className="list-inline font-small text-uppercase">
                                    {
                                        categories.length > 0 &&
                                            categories.map((category) => (
                                                <li key={category.pk_cat_key} className="list-inline-item">
                                                    <Link to={`/category/${category.pk_cat_key}`}>{category.cat_name}</Link>{" "}
                                                </li>
                                            ))
                                        // ) : (
                                        //     <>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">World</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">U.S.</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Politics</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">N.Y.</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Business</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Opinion</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Tech</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Science</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Health</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Sports</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Arts</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Books</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Style</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Food</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Travel</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Magazine</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">T Magazine</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Real Estate</Link>
                                        //         </li>
                                        //         <li className="list-inline-item">
                                        //             <Link to="/home">Video</Link>
                                        //         </li>
                                        //     </>
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="row d-flex align-items-center justify-content-between">
                            <div className="col-12">
                                <div className="footer-copy-right">
                                    <p className="font-small text-muted">
                                        © 2024, PaperBoy | All rights reserved | Designed by{" "}
                                        <a href="https://capdigisoft.com/" target="_blank">
                                            CAP Digisoft Solutions
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
